import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { TodayTomorrowDatePipeModule } from '@sdvor/shared/ui';
import { AdmitadAnalyticsService } from './services';

function initAnalyticsFactory(injector: Injector): () => void {
  return () => {
    const admitadAnalyticsService = injector.get(AdmitadAnalyticsService);

    admitadAnalyticsService.init();
  };
}

@NgModule({
  imports: [TodayTomorrowDatePipeModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initAnalyticsFactory(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class AnalyticsFeatureModule {}
